export const getJournals = (companyName, projectName) => {
    return (dispatch, getState) => {
    (async () => {
      let req = {};
      req.owner=companyName;
      req.projectName=projectName;
      req.status="open,reopened,resolved,assigned"
      const rawResponse = await fetch('https://us-central1-multilanguage-dacbe.cloudfunctions.net/filterTapes', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
      });
      const journals = await rawResponse.json();
    
      console.log(journals);
      if (journals !== undefined) {
        dispatch({ type: 'JOURNALS_RETRIEVED', journals});
        //this.setState({"journalLogs" : content});
      }

    })();
    }
}

export const watchJournals = (companyName, projectName) => {
  return (dispatch, getState, {getFirebase}) => {
    (async() => {
      const firebase = getFirebase();
      let snapshot = await firebase.database().ref("users").child(getState().firebase.auth.uid + "/assignedTapes").once("value");//, (snapshot) => {
      let journals = snapshot.val();
      let journalArray = new Array();
      var keys = Object.keys(journals);
      for (var i = 0; i < keys.length; i++) {
        let assignedJournal = journals[keys[i]];
        if (assignedJournal.archived !== undefined && assignedJournal.archived === true) {
          continue;
        }
        
        assignedJournal.ID = keys[i];
        let journalSnapshot = await firebase.database().ref("tapes").child(keys[i]).once("value");
        let journal = journalSnapshot.val();
        if (journal == null || journal.locationProject !== projectName) {
          continue;
        }
        assignedJournal.status = journal.status;
        assignedJournal.assignedTo = journal.assignedTo;
        assignedJournal.preview = "Preview";
        assignedJournal.dueDate = journal.dueDate;
        assignedJournal.criticality = journal.criticality;
        journalArray.push(assignedJournal);
      }

      dispatch({ type: 'JOURNALS_RETRIEVED', journals: journalArray});
    })();
 
  }
}

export const setJournalRowSelected = (journalRow, selected) => {
  return (dispatch, getState) => {
  (async () => {
    const state = getState();
    const journalRows = state.journal.journalRows;
    if (journalRows != undefined) {
      journalRows[journalRow] = selected;
      dispatch({ type: 'JOURNAL_ROW_SELECTED', journalRows});
    }
      
      //this.setState({"journalLogs" : content});
  })();
  }
}

export const setAllJournalRowsSelected = (selected) => {
  return (dispatch, getState) => {
  (async () => {
    const state = getState();

    const journalRows = state.journal.journalRows;
    if (journalRows != undefined) {
      for (var i = 0; i < journalRows.length; i++) {
        journalRows[i] = selected;
      }
      dispatch({ type: 'JOURNAL_ROW_SELECTED', journalRows});
      dispatch({type: 'JOURNAL_ROW_SELECTALL', selected});
    }
      
      //this.setState({"journalLogs" : content});
  })();
  }
}

export const archiveSelectedJournalsPopup = (popup) => {
  return (dispatch, getState) => {
  (async () => {
    const state = getState();

    
      dispatch({type: 'JOURNAL_SHOW_POPUP', popup});
    }
      
      //this.setState({"journalLogs" : content});
  
  )();
  }
}

export const assignSelectedJournalsPopup = (popup, anchor) => {
  return (dispatch, getState) => {
  (async () => {
    const state = getState();

    
      dispatch({type: 'JOURNAL_SHOW_ASSIGN_POPUP', popup, anchor});
    }
      
      //this.setState({"journalLogs" : content});
  
  )();
  }
}

export const changeStatusPopup = (popup, anchor) => {
  return (dispatch, getState) => {
  (async () => {
    const state = getState();

    
      dispatch({type: 'JOURNAL_CHANGE_STATUS_POPUP', popup, anchor});
    }
      
      //this.setState({"journalLogs" : content});
  
  )();
  }
}

export const changeDueDatePopup = (popup) => {
  return (dispatch, getState) => {
  (async () => {
    const state = getState();

    
      dispatch({type: 'JOURNAL_CHANGE_DUE_DATE_POPUP', popup});
    }
      
      //this.setState({"journalLogs" : content});
  
  )();
  }
}

export const archiveSelected = () => {
  return (dispatch, getState) => {
  (async () => {

    const journalRows =  getState().journal.journalRows;
    const journals =  getState().journal.journals;
    for (var i = 0; i < journalRows.length; i++) {
      if (journalRows[i] === false) {
        continue;
      }
    
      let req = {};
      req.tapeID=journals[i].ID;
      req.userID = getState().firebase.auth.uid;
      const rawResponse = await fetch('https://us-central1-multilanguage-dacbe.cloudfunctions.net/archiveTape', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
      });
    
    }
    dispatch({type: 'JOURNALS_UPDATED'});

  })();
  }
}

export const setSelectedJournalStatus = (statusAction) => {
  return (dispatch, getState) => {
  (async () => {

    const journalRows =  getState().journal.journalRows;
    const journals =  getState().journal.journals;
    for (var i = 0; i < journalRows.length; i++) {
      if (journalRows[i] === false) {
        continue;
      }
    
      let req = {};
      req.tapeID=journals[i].ID;
      req.userID = getState().firebase.auth.uid;
      req.action = statusAction;
      const rawResponse = await fetch('https://us-central1-multilanguage-dacbe.cloudfunctions.net/changeStatus', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
      });
      console.log(rawResponse);
    }
    dispatch({type: 'JOURNALS_UPDATED'}, null);

  })();
  }
}

export const setSelectedJournalAssignment = (assignment) => {
  return (dispatch, getState) => {
  (async () => {

    const journalRows =  getState().journal.journalRows;
    const journals =  getState().journal.journals;
    for (var i = 0; i < journalRows.length; i++) {
      if (journalRows[i] === false) {
        continue;
      }
    
      let req = {};
      req.tapeID=journals[i].ID;
      req.userID = getState().firebase.auth.uid;
      req.assignmentLabel = assignment;
      const rawResponse = await fetch('https://us-central1-multilanguage-dacbe.cloudfunctions.net/assignTape', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
      });
      console.log(rawResponse);
    }
    dispatch({type: 'JOURNALS_UPDATED'}, null);

  })();
  }
}

export const setSelectedDueDate = (date) => {
  return (dispatch, getState) => {
  (async () => {

    const journalRows =  getState().journal.journalRows;
    const journals =  getState().journal.journals;
    for (var i = 0; i < journalRows.length; i++) {
      if (journalRows[i] === false) {
        continue;
      }
    
      let req = {};
      req.tapeID=journals[i].ID;
      req.userID = getState().firebase.auth.uid;
      req.criticality = "urgent";
      req.dueDate = date;
      const rawResponse = await fetch('https://us-central1-multilanguage-dacbe.cloudfunctions.net/changeCriticality', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
      });
      console.log(rawResponse);
    }
    dispatch({type: 'JOURNALS_UPDATED'}, null);

  })();
  }
}


// WEBPACK FOOTER //
// ./src/store/actions/journalActions.js